export default "/images/vendor/@coreui/icons/svg/flag/cif-tt.svg?6479ef395f5d246710d97c7319d2737f";